import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=3d5392a1"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"
import style0 from "./Dash.vue?vue&type=style&index=0&id=3d5392a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports